import Tooltip from './Tooltip';
export type { TooltipProps } from './Tooltip.types';
export { TOOLTIP_POSITION } from './Tooltip.types';

export default Tooltip;
